import { render } from "./QualificationGlobalView.vue?vue&type=template&id=84be0e52"
import script from "./QualificationGlobalView.vue?vue&type=script&lang=js"
export * from "./QualificationGlobalView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__